import _ from 'underscore';
import { getNumericDeclension } from '@culture/common-helpers/string';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { nationalProjectCultureTagId } = publicRuntimeConfig.entities;

export const MISSING_VIDEO_STUB_TEXT =
	'Видеозапись недоступна для просмотра по решению правообладателя';

export const DISCLAIMERS_HASH = {
	youtube:
		'Внимание: видеоконтент в плеерах YouTube может быть недоступен. Это связано с замедлением скорости загрузки видеохостинга YouTube и не зависит от портала «Культура.РФ».'
};

const videoTypesHash = {
	movie: 'Фильм',
	lecture: 'Лекция',
	performance: 'Спектакль',
	concert: 'Концерт',
	broadcast: 'Трансляция'
};

const videoSubTypesHash = {
	episode: 'Серия',
	trailer: 'Трейлер',
	part: 'Часть'
};

export const makeMovieSlides = (materials, type) => {
	const movieSlides = [];
	const moviesGroups = _(
		materials
			.filter(
				(material) =>
					material.type === 'video' && material.status === 'published'
			)
			.map((material) => ({
				...material,
				player: material.playerMock || material.player
			}))
	).groupBy((material) => material.subType || 'part');

	if (moviesGroups.trailer) {
		_(moviesGroups.trailer).each((video, index) => {
			const parsedMovie = {
				video,
				type: 'trailer',
				title: videoSubTypesHash.trailer
			};

			if (moviesGroups.trailer.length > 1) {
				parsedMovie.title += ` ${index + 1}`;
			}

			movieSlides.push(parsedMovie);
		});
	}

	if (moviesGroups.episode) {
		_(moviesGroups.episode)
			.sortBy('seriesPosition')
			.forEach((video, index) => {
				const parsedMovie = { video, type: 'episode' };

				if (moviesGroups.episode.length > 1) {
					parsedMovie.title = `${videoSubTypesHash.episode} ${index + 1}`;
				} else {
					parsedMovie.title = videoTypesHash[type];
				}

				movieSlides.push(parsedMovie);
			});
	}

	if (moviesGroups.part) {
		_(moviesGroups.part).each((video, index) => {
			const parsedMovie = { video, type: 'part' };

			if (moviesGroups.part.length > 1) {
				parsedMovie.title = `${videoSubTypesHash.part} ${index + 1}`;
			} else {
				parsedMovie.title = video.title;
			}

			movieSlides.push(parsedMovie);
		});
	}

	return movieSlides;
};

const wordVariantsHash = {
	episode: {
		single: 'серия',
		some: 'серии',
		many: 'серий'
	},
	part: { single: 'часть', some: 'части', many: 'частей' }
};

export const getSlideText = (slides) => {
	const countsByType = _.countBy(slides, 'type');

	const textParts = Object.entries(countsByType).reduce(
		(memo, [type, count]) => {
			const wordVariants = wordVariantsHash[type];

			if (wordVariants && count > 1) {
				memo.push(`${count} ${getNumericDeclension(count, wordVariants)}`);
			}
			return memo;
		},
		[]
	);

	return textParts.join(', ');
};

export const getIsWasBroadcast = (movie) =>
	movie && movie.type !== 'broadcast' && movie.broadcastType;

export const getMovieHasNationalProjectCultureTag = (tags) =>
	_(tags).findWhere({ _id: nationalProjectCultureTagId });

export const isExternalPlayer = (
	{ withVideo, playerType, materials },
	serviceName
) =>
	!!withVideo &&
	playerType === 'external' &&
	materials.find((material) => material?.player?.includes(serviceName));

export const isYoutubePlayer = ({ withVideo, playerType, materials }) =>
	isExternalPlayer({ withVideo, playerType, materials }, 'youtube.com');
